import CanShow from "./CanShow";
import DetailedReport from "@/features/reports/detailedReport/Index";
import FinancialReport from "@/features/reports/financialReport/Index";
import NationalCenterReport from "@/features/reports/nationalCenterReport/Index";

export const reportsRoutes = [
  {
    path: "/reports/detailed",
    element: <CanShow page={<DetailedReport />} ifHas={["requiredReports"]} />,
  },
  {
    path: "/reports/financial",
    element: (
      <CanShow
        page={<FinancialReport />}
        ifHas={["financialSupervisorReport"]}
      />
    ),
  },
  {
    path: "/reports/national-center",
    element: (
      <CanShow
        page={<NationalCenterReport />}
        ifHas={["nationalCenterReport"]}
      />
    ),
  },
];
